import { useTranslation } from 'next-i18next'
import { FC, useEffect, useMemo } from 'react'

import Heading from '@/components/Heading'
import Meta from '@/components/Meta'
import NetworkCard from '@/components/NetworkCard'
import NetworkProps from '@/components/NetworkCard/NetworkProps.interface'

import { TextDataType } from '@/types/TextData'

import styles from './Networks.module.scss'
import { useTexts } from '@/bus/texts'
import { AboutNetworks, Reward } from '@/sections'

interface Props {
  data?: TextDataType
}

export const Networks: FC<Props> = ({ data = {} }) => {
  const {
    i18n: { language = 'ru' }
  } = useTranslation()

  const { getTextsBySlug, clearTexts, data: textData = {} } = useTexts()

  useEffect(() => {
    getTextsBySlug({ slug: 'networks', lang: language })

    return () => {
      clearTexts()
    }
    // eslint-disable-next-line
  }, [])

  const {
    children = [],
    title = '',
    meta = {}
  } = useMemo(() => ({ ...data, ...textData }), [data, textData])

  return (
    <>
      <Meta {...meta} />
      <AboutNetworks />
      <section className={styles['networks']}>
        <div className={styles['networks__inner']}>
          <Heading level={3} className={styles['networks__heading']}>
            {title}
          </Heading>
          <div className={styles['networks__list']}>
            {children.map(({ slug = '', ...rest }: NetworkProps) => (
              <NetworkCard
                key={slug}
                className={styles['networks__list-item']}
                slug={slug.replace('networks-', '')}
                {...rest}
              />
            ))}
          </div>
        </div>
      </section>
      <Reward />
    </>
  )
}
